export class ComponentCompileError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ComponentCompileError";
  }
}

export class ComponentValidationError extends ComponentCompileError {
  constructor(message: string) {
    super(message);
    this.name = "ComponentValidationError";
  }
}
